import React from 'react';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';

import { ImageSection, TextSection } from '../../styles/Section';
import { StyledTypography } from '../../styles/Typography';

import { StyledSection } from './styles/Section';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

function SectionBucket() {
  return (
    <StyledSection>
      <TextSection>
        <StyledTypography
          variant="title"
          intlKey="FGTS.BUCKET.TITLE"
        />
        <StyledTypography
          variant="subtitle"
          intlKey="FGTS.BUCKET.SUBTITLE"
        />
      </TextSection>
      <ImageSection>
        <FormattedMessage id="FGTS.BUCKET.ALT_IMAGE">
          {([alt]) => (
            <ResponsiveImages
              fileName="mockup-conta-fgts/mockup-conta-fgts.jpg"
              alt={alt}
              width="375px"
              loading="lazy"
            />
          )}
        </FormattedMessage>
      </ImageSection>
    </StyledSection>
  );
}

export default React.memo(SectionBucket);
